// Общие хуки А.4.4.2+3 — событийная шина.
// Не дублируем тут саму логику, только маршрутизация:
//   onUnitSummoned — Призыв/размещение/возврат союзного юнита (для Ликвидатор-эксперта).
//   recomputeAuras — пересчёт ауры Второго директора (после изменения Влияния, размещения, смерти).

import { likvidatorEkspertOnAllySummon } from './likvidator-ekspert.js';
import { recomputeDirectorAura } from './vtoroy-direktor.js';
// C.1: Цепь командования удалена. Подкрепление — новая фракционная аура Глобала.
import { recomputeLineTriggers, clearDerivedKeywordsFor } from '../../keywords/line-triggers.js';
import { recomputeReinforcement } from '../../keywords/reinforcement.js';
import {
  warnUnimplementedGlobalAbilities,
  warnUnimplementedLivLifeAbilities
} from '../warn-unimplemented.js';

// Б.1.d: late-binding для дополнительных обработчиков onUnitSummoned (избегаем cycle).
// Регистрируется из syntetics/index.js (Раст passive, Списанный дрон onSummon).
// `var` вместо let — чтобы registerXxx можно было вызывать в TDZ-период
// циклической инициализации модулей (generator_pomeh.js регистрируется
// при импорте мид-load).
// eslint-disable-next-line no-var
var _onUnitSummonedExtraHandlers;
export function registerUnitSummonedExtraHandler(fn) {
  if (!_onUnitSummonedExtraHandlers) _onUnitSummonedExtraHandlers = [];
  _onUnitSummonedExtraHandlers.push(fn);
}

// В.1.d: late-binding для onUnitLeftField (Генератор помех перепересчитывает Ауру).
// eslint-disable-next-line no-var
var _onUnitLeftFieldExtraHandlers;
export function registerUnitLeftFieldExtraHandler(fn) {
  if (!_onUnitLeftFieldExtraHandlers) _onUnitLeftFieldExtraHandlers = [];
  _onUnitLeftFieldExtraHandlers.push(fn);
}

// В.1.d: late-binding «после onTurnStart» — для пересчёта аур (Генератор мог
// проснуться). Вызывается в конце onTurnStart в deus/index.js.
// eslint-disable-next-line no-var
var _onTurnStartExtraHandlers;
export function registerOnTurnStartExtraHandler(fn) {
  if (!_onTurnStartExtraHandlers) _onTurnStartExtraHandlers = [];
  _onTurnStartExtraHandlers.push(fn);
}
export function fireOnTurnStartExtras(state) {
  if (!_onTurnStartExtraHandlers) return;
  for (const fn of _onTurnStartExtraHandlers) fn(state);
}

// В.1.d: late-binding «после onUnitDied» — для пересчёта Ауры Генератора
// (если умер сам Генератор, или враг под его Аурой). onUnitDied — путь
// для боевых смертей, не вызывает onUnitLeftField.
// eslint-disable-next-line no-var
var _onUnitDiedExtraHandlers;
export function registerOnUnitDiedExtraHandler(fn) {
  if (!_onUnitDiedExtraHandlers) _onUnitDiedExtraHandlers = [];
  _onUnitDiedExtraHandlers.push(fn);
}
export function fireOnUnitDiedExtras(state, payload) {
  if (!_onUnitDiedExtraHandlers) return;
  for (const fn of _onUnitDiedExtraHandlers) fn(state, payload);
}

// В.2.d-2: late-binding «после onEndOfTurn» — общий хук в конце хода
// (после Ф5, до cleanup). Используется Лабораторной крысой Лив Лайф (триггер
// «в конце хода: +1/0/1 + призыв копии») и в будущем Главной Лабораторией.
// eslint-disable-next-line no-var
var _onEndOfTurnExtraHandlers;
export function registerOnEndOfTurnExtraHandler(fn) {
  if (!_onEndOfTurnExtraHandlers) _onEndOfTurnExtraHandlers = [];
  _onEndOfTurnExtraHandlers.push(fn);
}
export function fireOnEndOfTurnExtras(state) {
  if (!_onEndOfTurnExtraHandlers) return;
  for (const fn of _onEndOfTurnExtraHandlers) fn(state);
}

// ownerIdx — владелец нового юнита, card — Card.
export function onUnitSummoned(state, ownerIdx, card) {
  // Ликвидатор-эксперт: триггер «появился союзник» (А.4.5-fix5).
  likvidatorEkspertOnAllySummon(state, ownerIdx, card);
  // Аура Второго директора — пересчёт для нового юнита.
  recomputeDirectorAura(state);
  // Б.1.d: Синтетикс-расширения (Раст passive, Списанный дрон onSummon).
  if (_onUnitSummonedExtraHandlers) {
    for (const fn of _onUnitSummonedExtraHandlers) fn(state, ownerIdx, card);
  }
  // C.1: Цепь командования удалена. Подкрепление пересчёт при появлении юнита.
  recomputeReinforcement(state);
  // В.1.c-1: линейно-триггерные keyword'ы — Снайпер/Мех/Расчёт могли встать на «свою» линию.
  recomputeLineTriggers(state);
  // В.1.a-fix3: warning о пропущенных способностях карт Глобала (one-shot per card.id|field).
  warnUnimplementedGlobalAbilities(card);
  // В.2.a: то же для карт Лив Лайф (one-shot per card.id|field).
  warnUnimplementedLivLifeAbilities(card);
}

// Пересчёт ауры — обёртка для вызова извне (после addInfluence, manipulyatsiya).
export function onInfluenceChanged(state) {
  recomputeDirectorAura(state);
}

// Юнит ушёл с поля (смерть/возврат в руку) — пересчитать ауры с зависимостью от состава поля.
export function onUnitLeftField(state, ownerIdx, card) {
  recomputeDirectorAura(state);
  // C.1: Цепь командования удалена. Пересчёт Подкрепления при уходе с поля.
  recomputeReinforcement(state);
  // В.1.c-1: derived-keyword'ы ушедшего юнита снимаем (smoke на отсутствие leak'а).
  clearDerivedKeywordsFor(card);
  // Соседи могут потерять свой derived (если эта карта была их триггер-носителем —
  // не наш кейс, но recompute дешёвый).
  recomputeLineTriggers(state);
  // В.1.d: late-bound extras (Аура Генератора и т.п.).
  if (_onUnitLeftFieldExtraHandlers) {
    for (const fn of _onUnitLeftFieldExtraHandlers) fn(state, ownerIdx, card);
  }
}

// Полноценное событие смерти юнита — для deathrattle/Сины/Аналитика/Фудзи.
// Вызывается из Действий (Vzlom, Манипуляция) и других не-боевых источников смерти.
// Фактический dispatch — через позднюю инжекцию: index.js регистрирует обработчик
// при загрузке, чтобы избежать циклических импортов.
// var — чтобы registerUnitDiedHandler можно было вызвать в TDZ-период
// циклической инициализации модулей (В.1.g: импорт polkovnik_mit.js
// через global/index.js может образовать цикл через summonUnit→hooks).
// eslint-disable-next-line no-var
var _onUnitDiedHandler = null;
export function registerUnitDiedHandler(fn) { _onUnitDiedHandler = fn; }
export function dispatchUnitDied(state, payload) {
  if (_onUnitDiedHandler) _onUnitDiedHandler(state, payload);
  else recomputeDirectorAura(state);
}
